import $ from 'jquery';
import 'jquery-ui/ui/widgets/accordion';

$(document).ready(function () {
    $('.accordion').accordion({
        collapsible: true,
        active: false,
        heightStyle: 'content',
        header: '.accordion__itemHeader',
        icons: false
    });
});